import { render, staticRenderFns } from "./AddMasterclass.vue?vue&type=template&id=be1480a8&scoped=true&"
import script from "./AddMasterclass.vue?vue&type=script&lang=js&"
export * from "./AddMasterclass.vue?vue&type=script&lang=js&"
import style0 from "./AddMasterclass.vue?vue&type=style&index=0&id=be1480a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1480a8",
  null
  
)

export default component.exports